export enum ServicePriority {
  low = 'low',
  medium = 'medium',
  high = 'high',
}
